/* global axios */

import Cookies from 'js-cookie';
import endPoints from './endPoints';
import {
  clearCookiesOnLogout,
  deleteIndexedDBOnLogout,
} from '../store/utils/api';

// The devise_token_auth header set — the only keys from the session cookie
// that belong on authenticated requests.
export const AUTH_HEADER_KEYS = [
  'access-token',
  'token-type',
  'client',
  'expiry',
  'uid',
];

export default {
  validityCheck() {
    const urlData = endPoints('validityCheck');
    return axios.get(urlData.url);
  },
  logout() {
    const urlData = endPoints('logout');
    const fetchPromise = new Promise((resolve, reject) => {
      axios
        .delete(urlData.url)
        .then(response => {
          deleteIndexedDBOnLogout();
          clearCookiesOnLogout();
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
    return fetchPromise;
  },
  hasAuthCookie() {
    return (
      !!Cookies.get('cw_d_session_info') ||
      !!localStorage.getItem('cw_cti_auth')
    );
  },
  getAuthData() {
    if (this.hasAuthCookie()) {
      const savedAuthInfo =
        Cookies.get('cw_d_session_info') || localStorage.getItem('cw_cti_auth');
      return JSON.parse(savedAuthInfo || '{}');
    }
    return false;
  },
  // Sends only the fields the caller gives. A field that is left out (or is
  // null) is not sent, so the server keeps its current value.
  profileUpdate({
    displayName,
    customLine,
    avatar,
    emailSignaturePicture,
    ...profileAttributes
  }) {
    const formData = new FormData();
    Object.keys(profileAttributes).forEach(key => {
      const value = profileAttributes[key];
      if (value !== undefined && value !== null) {
        formData.append(`profile[${key}]`, value);
      }
    });
    if (displayName !== undefined) {
      formData.append('profile[display_name]', displayName || '');
    }
    if (customLine !== undefined) {
      formData.append('profile[custom_line]', customLine || '');
    }
    if (avatar) {
      formData.append('profile[avatar]', avatar);
    }
    if (emailSignaturePicture) {
      formData.append(
        'profile[email_signature_picture]',
        emailSignaturePicture
      );
    }
    return axios.put(endPoints('profileUpdate').url, formData);
  },

  profilePasswordUpdate({ currentPassword, password, passwordConfirmation }) {
    return axios.put(endPoints('profileUpdate').url, {
      profile: {
        current_password: currentPassword,
        password,
        password_confirmation: passwordConfirmation,
      },
    });
  },

  updateUISettings({ uiSettings }) {
    return axios.put(endPoints('profileUpdate').url, {
      profile: { ui_settings: uiSettings },
    });
  },

  updateAvailability(availabilityData) {
    return axios.post(endPoints('availabilityUpdate').url, {
      profile: { ...availabilityData },
    });
  },

  updateAutoOffline(accountId, autoOffline = false) {
    return axios.post(endPoints('autoOffline').url, {
      profile: { account_id: accountId, auto_offline: autoOffline },
    });
  },

  deleteAvatar() {
    return axios.delete(endPoints('deleteAvatar').url);
  },

  deleteEmailSignaturePicture() {
    return axios.delete(endPoints('deleteEmailSignaturePicture').url);
  },

  resetPassword({ email }) {
    const urlData = endPoints('resetPassword');
    return axios.post(urlData.url, { email });
  },

  setActiveAccount({ accountId }) {
    const urlData = endPoints('setActiveAccount');
    return axios.put(urlData.url, {
      profile: {
        account_id: accountId,
      },
    });
  },
  resendConfirmation() {
    const urlData = endPoints('resendConfirmation');
    return axios.post(urlData.url);
  },
  regenerateAccessToken() {
    const urlData = endPoints('regenerateAccessToken');
    return axios.post(urlData.url);
  },
};
